module.exports = __webpack_public_path__ + "img/side-menu-for-categories.ed4ef7d7.svg";